import React, { FC } from 'react'

interface Props {
  errors: { message: string | null; type: string }[]
}

const FormErrors: FC<Props> = ({ errors }) => (
  <div className="checkout-form__errors" style={{ ...(errors.length ? { display: 'block' } : undefined) }}>
    {errors.map(({ message }, index) => (
      <p key={index}>{message}</p>
    ))}
  </div>
)

export default FormErrors
